export default __webpack_public_path__ + "049a8cdeb1c2cb977ed8fa81b7c751d3.png";